import { ChangeDetectorRef, Component, ElementRef, OnInit, inject, input, output, viewChild } from "@angular/core";
import { AuthenticationService } from "core/authentication.service";
import { DisclaimerResource, NotificationResource } from "core/stages-client";
import { MutexService } from "common/concurrency/mutex.service";
import { NewDialogComponent } from "common/newdialog/dialog.component";
import { DialogHeaderComponent } from "common/newdialog/dialog-header.component";
import { TranslateModule } from "@ngx-translate/core";

import { ButtonsBottomComponent } from "common/buttons/buttons-bottom.component";
import { ButtonComponent } from "common/buttons/button.component";
import { SafePipe } from "common/download/safe.pipe";

@Component({
	selector: "stages-disclaimer",
	templateUrl: "./disclaimer-login.component.html",
	styleUrls: ["./disclaimer-login.component.scss"],
	imports: [
		NewDialogComponent,
		DialogHeaderComponent,
		TranslateModule,
		ButtonsBottomComponent,
		ButtonComponent,
		SafePipe,
	],
})
export class DisclaimerLoginComponent implements OnInit {
	private authService = inject(AuthenticationService);
	private notificationResource = inject(NotificationResource);
	private mutexService = inject(MutexService);
	private disclaimerResource = inject(DisclaimerResource);
	private changeDetector = inject(ChangeDetectorRef);

	acceptButtonVisible: boolean = false;
	fileError: boolean = false;
	textContent: string = "";
	isScrollable: boolean = false;

	readonly dialog = viewChild<NewDialogComponent>("dialog");

	readonly disclaimerTextElement = viewChild<ElementRef>("disclaimerTextElement");

	readonly disclaimerVersion = input<string | null>(null);

	readonly markedDisclaimerAsAccepted = output<boolean>();

	// eslint-disable-next-line @typescript-eslint/no-misused-promises -- TODO: Remove this comment and fix warnings!
	async ngOnInit(): Promise<void> {
		if (this.disclaimerVersion() !== null) {
			try {
				this.textContent = await this.disclaimerResource.getDisclaimerVersionText();
				this.changeDetector?.detectChanges();
				const text = this.disclaimerTextElement()?.nativeElement;
				this.isScrollable = text.scrollHeight > text.clientHeight;
				this.acceptButtonVisible = !this.isScrollable;
			} catch {
				this.fileError = true;
			}
		}
	}

	enableAcceptButton(): void {
		const scrollableText = this.disclaimerTextElement()?.nativeElement;
		if (scrollableText && this.isScrollable) {
			const scrollTop: number = scrollableText.scrollTop;
			const scrollOffset: number = scrollableText.offsetHeight;
			const scrollPos = scrollTop + scrollOffset;
			if (scrollPos >= scrollableText.scrollHeight) {
				this.acceptButtonVisible = true;
			}
		}
	}

	async logOutUser(): Promise<void> {
		await this.authService.logout(null);
	}

	acceptTerms(): void {
		const disclaimer = "Disclaimer";
		this.mutexService.invoke("markAsSeen" + disclaimer, async () =>
			this.notificationResource.markAsSeen({ objectType: "disclaimer", objectId: this.disclaimerVersion() }),
		);
	}
}
